module.exports = __webpack_public_path__ + "img/paper-clip.84a13560.svg";